import NrTooltip from '../NrTooltip/NrTooltip.vue';
import NrIconButton from '../NrIconButton/nr-icon-button.vue';
export default {
  components: {
    NrTooltip: NrTooltip,
    NrIconButton: NrIconButton
  },
  computed: {
    showTooltip: function showTooltip() {
      var _this$$slots$tip, _this$$slots, _this$$slots$tip2, _this$$slots2;
      return ((_this$$slots$tip = (_this$$slots = this.$slots).tip) === null || _this$$slots$tip === void 0 ? void 0 : _this$$slots$tip.call(_this$$slots)) && ((_this$$slots$tip2 = (_this$$slots2 = this.$slots).tip) === null || _this$$slots$tip2 === void 0 ? void 0 : _this$$slots$tip2.call(_this$$slots2).length);
    }
  }
};